import axios from 'axios';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import announce_message from '../mixins/announce_message';
import qs from 'qs';
import { csrfToken } from 'rails-ujs';
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken();
export default {
  mixins: [announce_message],
  methods: {
    /**
     * pathに対してgetする
     * @param  {Object} params
     * @param  {String} path
     * @param  {String} error_word
     */
    async getSelect(params, path, error_word) {
      const response = await axios.get(path, { params }).catch((error) => {
        console.log(error);
        alert(error_word);
      });
      return response;
    },
    async postMethod(params, path, error_word) {
      const response = await axios.post(path, params).catch((error) => {
        console.log(error);
        alert(error_word);
      });
      return response;
    },
    async patchMethod(params, path, error_word) {
      const response = await axios.patch(path, params).catch((error) => {
        console.log(error);
        alert(error_word);
      });
      return response;
    },
    async deleteMethod(params, path, error_word) {
      const paramsSerializer = (params) => qs.stringify(params);
      const response = await axios
        .delete(path, {
          params,
          paramsSerializer,
        })
        .catch((error) => {
          console.log(error);
          alert(error_word);
        });
      return response;
    },
  },
};
